import { Empty, Spin } from "antd";
import React from "react";

const CustomSpin = ({ data, isLoading, children, noDataMessage }) => {
  if (data?.length === 0) {
    return <Empty description={noDataMessage || "No Data Available!"} />;
  }

  return (
    <Spin spinning={isLoading} tip="Loading devices" size="medium">
      <>{children}</>
    </Spin>
  );
};

export default CustomSpin;
